<template>
  <div id="NotLoggedIn" class="bg-brand-secondary">
    <!--TODO::Refactor this section -->
    <!--adding a loader in case there is a token used for signing a user in-->
    <div v-if="loadingAuthLink">
      <b-spinner class="brand-primary"></b-spinner>
    </div>
    <div v-else><Login /></div>
  </div>
</template>

<script>
// @ is an alias to /src
import Login from "@/components/NotLoggedIn/Login.vue";
import { mapGetters } from "vuex";
import { generateCodeVerifier, generateCodeChallenge } from "@/utils/pkce";
import axios from "axios";
import config from "@/config/constants";

export default {
  name: "home",
  components: {
    Login
  },
  data() {
    return {
      screen: 0,
      showWarning: null,
      layaLogin: true,
      accessLogin: true,
      loadingAuthLink: true,
    };
  },
  async mounted() {
	  this.accessLogin = false;
    //TODO refactor this into separate pages ands routes

    // Applying the login process if the token was found in localStorage using the saved route, otherwise redirecting to the Login page
    // let token = localStorage.getItem("access_token");
    // if (token === "null") {
    //   this.loadingAuthLink = false;
    //   await this.getAuthProviderLoginUiUrl("simplyhealth");
    // } else {
    //   const validatedUser = await this.validateAccessToken(token);
    //   if (validatedUser.data.success && validatedUser.status === 200) {
    //     this.$store.commit("setUser", validatedUser.data);
    //     this.$store.commit("setInitialCourseProgress");
    //     this.$store.commit("setLanguage", validatedUser.data.lang);
    //     const query = localStorage.getItem("queryWithoutToken");
    //     window.location.replace(query);
    //   }
    //   this.loadingAuthLink = false;
    // }
	  
	  
	  
	  await this.getAuthProviderLoginUiUrl("simplyhealth");
	  this.loadingAuthLink = false;
		
	  
	  
	  
	  
    // if (this.$route.name === "verifyEmail") {
    //   this.screen = 3;
    // } else if (this.$route.name === "resetPassword") {
    //   this.screen = 4;
    // } else if (this.$route.name === "forgotPassword") {
    //   this.screen = 2;
    // } else if (this.$route.query.org) {
    //   this.orgCode = this.$route.query.org;
    //   this.screen = 1;
    // } else if (this.$route.name.includes("coaching-survey")) {
    //   this.screen = 8;
    // } else if (this.$route.name.includes("survey")) {
    //   this.screen = 9;
    // } else if (this.$route.name.includes('twoFactor')) {
    //   this.screen = 10;
    // } else {
    //   this.screen = 0;
    // }
  },
  methods: {
    // changeScreen(screen) {
    //   this.screen = screen;
    // },
    // toggleAccessLogin() {
    //   this.accessLogin = !this.accessLogin;
    // },
    async getAuthProviderLoginUiUrl(oauthProvider) {
      try {
        const res = await this.api({
          path: `api/u/oauth/${oauthProvider}/get-auth-provider-url`
        });

        if (!res.success) {
          alert(`Failed to get ${oauthProvider} Auth URL`);
          return;
        }
        const codeVerifier = generateCodeVerifier(128);
        const codeChallenge = await generateCodeChallenge(codeVerifier);

        sessionStorage.setItem(`code_verifier_${oauthProvider}`, codeVerifier);

        const authUrl = new URL(res.data.auth_url);

        authUrl.searchParams.append('code_challenge_method', 'S256');
        authUrl.searchParams.append('code_challenge', codeChallenge);

        window.location.replace(authUrl.href);

        // this.$set(this.authProvider[oauthProvider], 'loginUiUrl', authUrl.href);
      } catch (error) {
        console.error(error);
      }
    },
    // async validateAccessToken(token) {
    //   try {
    //     const payload = {
    //       security_token: token
    //     };
    //     let response = await axios.post(
    //       config.api_env + "/application/api/u/auth/get-access-token",
    //       payload,
    //       config.options
    //     );
    //     if (response.data.authinticated) this.loadingAuthLink = false;
    //     return response; // Or check response.data.valid, depending on your backend
    //   } catch {
    //     return false;
    //   }
    // }
  },
  computed: {
    ...mapGetters(["warning", "skin", "subdomain","navType"]),
  },
  watch: {
    warning(newWarning) {
      if (newWarning) {
        this.showWarning = true;
      } else this.showWarning = false;
    },
    $route(newRoute) {
      if (newRoute.name === "verifyEmail") {
        this.screen = 3;
      } else if (newRoute.name === "verifyEmail") {
        this.screen = 4;
      } else if (newRoute.name.includes('twoFactor')) {
        this.screen = 10;
      } else {
        this.screen = 0;
      }
    },
  },
};
</script>
<style lang="less">
#NotLoggedIn {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  &:after {
    //IE vertical centre
    content: "";
    min-height: inherit;
    font-size: 0;
  }
  .warning {
    position: absolute;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.4);
    top: 0;
    left: 0;
  }
  .dropdown-toggle {
    color: inherit;
    font-family: "PlusJakartaSansRegular";
    letter-spacing: 0;
    background: transparent;
    &:active {
      background: transparent;
    }
  }
  .dropdown-menu {
    font-size: 1.4rem;
  }
  .container {
    .page-content {
      background-color: #fff;
      border-radius: 30px;
      overflow: hidden;
      min-height: 400px;
      padding: 0px !important;
      @media screen and (max-width: 768px) {
        border-radius: 0px;
      }
      .img-part {
        padding-left: 0px;
        .login-bg {
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
          position: relative;
          height: 100%;
          width: 100%;
          .heart-placeholder {
            position: absolute;
            top: 10%;
            left: 10%;
            height: 10%;
            width: 10%;
            .heart-img {
              height: 65px;
            }
          }
          .login-image {
            height: 60%;
            width: 80%;
            background-image: url("/img/auth/_sign-in.svg");
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }
          .verify-image {
            position: absolute;
            top: 20%;
            left: 20%;
            height: 60%;
            width: 60%;
            background-image: url("/img/auth/_verify-email.svg");
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }
          .sign-up-image {
            position: absolute;
            top: 10%;
            left: 10%;
            height: 80%;
            width: 80%;
            background-image: url("/img/auth/_sign-up.svg");
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }
          .forgot-pass-image {
            position: absolute;
            top: 20%;
            left: 20%;
            height: 60%;
            width: 60%;
            background-image: url("/img/auth/_forgot-password.svg");
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }
        }
      }
      .logos {
        flex-wrap: nowrap;
        justify-content: center;
        .logo {
          flex-grow: 1;
          justify-content: center;
          align-items: center;
          //height: 25px;
          img {
            max-height: 100%;
            max-width: 100%;
          }
        }
      }
      .form {
        background: #ffffff;
        .form-content {
          padding: 25px;
          min-heigh: 795px;
          .form-logo {
            margin: 30px auto 30px auto;
            img {
              width: 100%;
            }
          }
          p {
            font-size: 1.7rem;
            font-family: "PlusJakartaSansRegular";
            text-align: center;
            &.small {
              font-size: 1.3rem;
            }
          }
          label {
            color: #8d8e92;
            font-size: 1.5rem;
            margin-left: 20px;
          }
          .form-control {
            background-color: #efeef2;
            height: 50px;
            border-radius: 25px;
            font-size: 1.8rem;
            font-family: "Open Sans", sans-serif;
          }
          .forgot-password {
            color: #8d8e92;
            font-size: 1.5rem;
            text-decoration: underline;
            margin-left: 20px;
          }
          .submit-form {
            margin: 50px 0 0 0;
            text-align: center;
            .btn {
              margin: 0 0 30px 0;
              padding: 0 50px;
              box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.3);
              &.disabled {
                cursor: default;
              }
            }
          }
          .new-here {
            font-size: 1.7rem;
            text-decoration: none;
            text-align: center;
            margin-bottom: 25px;
          }
          .invalid-feedback {
            font-size: 1.4rem;
            color: red;
          }
          .is-valid {
            border-color: #ced4da;
            box-shadow: none;
          }
          .is-invalid,
          .is-valid {
            background-image: none;
          }
          .password-wrap {
            position: relative;
            .eye {
              font-size: 1.3rem;
              position: absolute;
              right: 20px;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .dark-mode-container {
    .darkModeText {
      color: white !important;
    }
  }
}
</style>
